import { Dialog, Transition } from '@headlessui/react';
import React, {
  CSSProperties,
  Fragment,
  ReactNode,
  useEffect,
  useState,
} from 'react';

import classNames from 'classnames';
import { createPortal } from 'react-dom';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  onClose: () => void;
  isOpen: boolean;
  className?: string;
  style?: CSSProperties;
  showAttribution?: boolean;
  applicationId?: string;
}

const ApideckIcon = () => (
  <img
    src="https://www.apideck.com/apideck-icon.png"
    alt="Apideck Logo"
    width={22}
    height={22}
    className="flex-shrink-0 rounded-full"
    style={{ display: 'inline-block' }}
    loading="eager"
  />
);

const ApideckLogoText = ({ className = '' }: { className?: string }) => (
  <svg
    width={65}
    height={15}
    viewBox="0 0 95 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1.2 9.05q.075-1.25.625-2.075t1.4-1.325a5.9 5.9 0 0 1 1.9-.7 10.5 10.5 0 0 1 2.15-.225q.975 0 1.975.15a5.8 5.8 0 0 1 1.825.525q.825.4 1.35 1.125.525.7.525 1.875v6.725q0 .875.1 1.675t.35 1.2H9.8a8 8 0 0 1-.175-.6 9 9 0 0 1-.075-.65 4.6 4.6 0 0 1-2 1.225q-1.15.35-2.35.35a6.4 6.4 0 0 1-1.725-.225 4 4 0 0 1-1.4-.7 3.4 3.4 0 0 1-.95-1.2Q.8 15.476.8 14.475q0-1.1.375-1.8a3.4 3.4 0 0 1 1-1.15 4.4 4.4 0 0 1 1.4-.625q.8-.225 1.6-.35t1.575-.2 1.375-.225.95-.425q.35-.3.325-.85 0-.575-.2-.9a1.2 1.2 0 0 0-.5-.525 1.6 1.6 0 0 0-.725-.25A5 5 0 0 0 7.1 7.1q-1.05 0-1.65.45t-.7 1.5zm8.2 2.625q-.225.2-.575.325a7 7 0 0 1-.725.175q-.375.075-.8.125t-.85.125q-.4.075-.8.2-.375.125-.675.35a1.54 1.54 0 0 0-.45.525q-.175.326-.175.825 0 .475.175.8T5 15.65q.3.175.7.25t.825.075q1.05 0 1.625-.35T9 14.8q.275-.5.325-1 .075-.5.075-.8zm12.83 4q-.85 0-1.45-.35a3 3 0 0 1-.975-.9 4.5 4.5 0 0 1-.524-1.325q-.15-.75-.15-1.525 0-.8.15-1.55t.5-1.325a2.96 2.96 0 0 1 .95-.925q.6-.375 1.474-.375.85 0 1.426.375.6.35.974.95.375.575.526 1.325.174.75.174 1.525t-.15 1.525-.524 1.325q-.35.55-.95.9-.576.35-1.45.35m-6.524-10.6v17.45h3.55V16.4h.05a4.3 4.3 0 0 0 1.65 1.45 5.2 5.2 0 0 0 2.224.475q1.425 0 2.476-.55A5.1 5.1 0 0 0 27.43 16.3a6.2 6.2 0 0 0 1.076-2.125q.35-1.2.35-2.5 0-1.376-.35-2.625-.35-1.275-1.076-2.225A5.4 5.4 0 0 0 25.606 5.3q-1.1-.575-2.625-.575-1.2 0-2.2.475-.999.475-1.65 1.525h-.05v-1.65zm18.933-2V.15h-3.55v2.925zm-3.55 2V18h3.55V5.075zM46.61 11.5q0 .8-.15 1.55t-.5 1.35a2.66 2.66 0 0 1-.95.925q-.575.35-1.45.35-.825 0-1.425-.35a3.5 3.5 0 0 1-.975-.95q-.375-.6-.55-1.35t-.175-1.5q0-.8.15-1.525.175-.75.525-1.325.375-.575.975-.925t1.475-.35 1.45.35.925.925q.375.55.525 1.3.15.725.15 1.525m.05 4.85V18h3.375V.15h-3.55v6.5h-.05a3.7 3.7 0 0 0-1.65-1.425 4.9 4.9 0 0 0-2.175-.5q-1.425 0-2.5.575a5.35 5.35 0 0 0-1.8 1.475 6.9 6.9 0 0 0-1.075 2.15q-.35 1.2-.35 2.5 0 1.35.35 2.6.375 1.25 1.075 2.225a5.4 5.4 0 0 0 1.825 1.525q1.1.55 2.55.55 1.275 0 2.275-.45 1.024-.475 1.65-1.525zm14.758-6.2h-5.775q.026-.375.15-.85.15-.476.475-.9.35-.425.9-.7.575-.3 1.425-.3 1.3 0 1.925.7.65.7.9 2.05m-5.775 2.25h9.325q.1-1.5-.25-2.875a6.9 6.9 0 0 0-1.15-2.45 5.5 5.5 0 0 0-2-1.7q-1.224-.65-2.875-.65-1.475 0-2.7.525-1.2.525-2.075 1.45a6.2 6.2 0 0 0-1.35 2.15 7.5 7.5 0 0 0-.475 2.7q0 1.5.45 2.75.475 1.25 1.325 2.15a5.85 5.85 0 0 0 2.075 1.4q1.225.475 2.75.475 2.2 0 3.75-1t2.3-3.325h-3.125q-.174.6-.95 1.15-.775.525-1.85.525-1.5 0-2.3-.775t-.875-2.5m20.23-2.775h3.476q-.075-1.25-.6-2.15a4.65 4.65 0 0 0-1.375-1.525 5.6 5.6 0 0 0-1.9-.925q-1.05-.3-2.2-.3-1.575 0-2.8.525a5.8 5.8 0 0 0-2.075 1.475q-.85.925-1.3 2.225-.425 1.275-.425 2.775 0 1.45.475 2.675a6.2 6.2 0 0 0 1.325 2.075 6.1 6.1 0 0 0 2.05 1.375q1.224.475 2.675.475 2.575 0 4.225-1.35t2-3.925h-3.425q-.176 1.2-.875 1.925-.675.7-1.95.7-.825 0-1.4-.375a2.96 2.96 0 0 1-.925-.95 4.8 4.8 0 0 1-.475-1.325 7 7 0 0 1-.15-1.425q0-.725.15-1.45.15-.75.5-1.35.374-.625.95-1 .575-.4 1.425-.4 2.274 0 2.625 2.225M81.754.15V18h3.55v-4.45l1.375-1.325L90.228 18h4.3l-5.425-8.175 4.875-4.75h-4.2l-4.475 4.65V.15z"
      fill="currentColor"
    />
  </svg>
);

const Modal: any = ({
  children,
  onClose,
  isOpen = false,
  showAttribution,
  applicationId,
  className = '',
  style = {},
}: Props) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const modalComponent = (
    <Transition.Root appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        onClose={onClose}
        style={style}
        className="apideck react-vault"
      >
        <div
          data-testid="backdrop"
          id="react-vault"
          className={classNames(
            'fixed inset-0 z-40 group overflow-y-auto bg-gray-400 bg-opacity-75',
            className
          )}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-8 h-8 absolute right-6 top-6 lg:w-10 lg:h-10 xl:top-8 xl:right-8 cursor-pointer text-gray-100 hover:text-white"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>

          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                className="inline-block w-full text-left max-w-sm p-6 my-12 lg:my-16 align-middle transition-all transform bg-white shadow-xl rounded-lg"
                id="react-vault-modal"
              >
                {children}
              </div>
            </Transition.Child>
            <Transition
              show={isOpen && showAttribution}
              as={Fragment}
              enter="ease-out duration-300 delay-300"
              enterFrom="opacity-0 translate-y-4"
              enterTo="opacity-100 translate-y-0"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-4"
            >
              <a
                className="fixed bottom-4 sm:bottom-5 left-1/2 -translate-x-1/2 xl:bottom-6 group/attribution inline-flex items-center gap-1.5 px-2 py-1.5 bg-white/95 backdrop-blur-sm rounded-full shadow-lg ring-1 ring-gray-200/50 text-gray-700 text-sm font-medium transition-shadow duration-200 ease-out hover:shadow-xl focus:outline-none"
                href={`https://apideck.com?utm_source=vault&utm_medium=referral&utm_campaign=powered_by${
                  applicationId ? `&customer_ref=${applicationId}` : ''
                }`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ApideckIcon />
                <span className="text-gray-500">Powered by</span>
                <ApideckLogoText className="-ml-0.5 group-hover/attribution:text-primary-600 transition-colors duration-200 ease-out" />
              </a>
            </Transition>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );

  return mounted ? createPortal(modalComponent, document.body) : null;
};

export default Modal;
